import React from 'react';
import { ContentfulMultilineText } from '../../../components/Contentful';
import './ArticleGallerySubheader.css';

interface ArticleGallerySubheaderProps {
  text?: string;
  contentfulText?: string;
  fallbackText?: string;
}

const ArticleGallerySubheader: React.FC<ArticleGallerySubheaderProps> = ({ 
  text, 
  contentfulText,
  fallbackText
}) => {
  return (
    <section className="article-gallery-subheader">
      <div className="article-gallery-subheader-content">
        {contentfulText ? (
          <ContentfulMultilineText 
            content={contentfulText} 
            fallback={fallbackText || text || 'Awasi was conceived from the idea that every journey should intimately connect us with nature to deeply discover new destinations and to enrich our own existence. May art and nature always inspire, elevate and transform us.'}
            as="p"
            className="intro-text"
          />
        ) : (
          <p className="intro-text">
            {fallbackText || text || 'Awasi was conceived from the idea that every journey should intimately connect us with nature to deeply discover new destinations and to enrich our own existence. May art and nature always inspire, elevate and transform us.'}
          </p>
        )}
      </div>
    </section>
  );
};

export default ArticleGallerySubheader;